var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArchive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    height: 16,
    viewBox: "0 0 32 32",
    width: 16,
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "rgb(0,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m27 3h-22a3 3 0 0 0 -3 3v3a3 3 0 0 0 2 2.82v14.18a3 3 0 0 0 3 3h18a3 3 0 0 0 3-3v-14.18a3 3 0 0 0 2-2.82v-3a3 3 0 0 0 -3-3zm-1 23a1 1 0 0 1 -1 1h-18a1 1 0 0 1 -1-1v-14h20zm2-17a1 1 0 0 1 -1 1h-22a1 1 0 0 1 -1-1v-3a1 1 0 0 1 1-1h22a1 1 0 0 1 1 1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m13 17h6a1 1 0 0 0 0-2h-6a1 1 0 0 0 0 2z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchive);
export default __webpack_public_path__ + "static/media/archive.9ccb448b1cd004265017730cafc80d8a.svg";
export { ForwardRef as ReactComponent };